import { capitalizeNamePart, capitalizeWords, formatFullName, formatWithLastInitial } from '../../utils/nameUtils';

export { capitalizeNamePart, capitalizeWords, formatFullName, formatWithLastInitial } from '../../utils/nameUtils';

export const buildPlayersById = (players = []) => new Map(players.map((player) => [player.id, player]));

export const createPlayerNameFormatter = (playersById, fallbackLabel = 'Jugadora sin identificar') => {
    return (playerId) => {
        const player = playersById?.get(playerId);
        if (!player) {
            if (playerId == null) return fallbackLabel;
            return `Jugadora #${playerId}`;
        }

        const rawFirst = player.firstName ?? player.first_name ?? '';
        const rawLast = player.lastName ?? player.last_name ?? '';

        let first = capitalizeNamePart(rawFirst);
        let last = capitalizeNamePart(rawLast);

        if (!first && player.name) {
            const normalizedName = capitalizeWords(player.name);
            const [firstFromName, ...restNameParts] = normalizedName.split(/\s+/);
            first = firstFromName ?? '';
            if (!last) {
                last = capitalizeNamePart(restNameParts.join(' '));
            }
        }

        const formatted = formatWithLastInitial(first, last);

        if (formatted) return formatted;
        if (player.name) return capitalizeWords(player.name);

        return `Jugadora #${playerId}`;
    };
};
